import axios from 'axios';
import store from '../../store/index';

export default {
	loadDays(showDeleted) {
		return axios.get(`/api/days?deleted=${showDeleted}`);
	},

	loadDuties() {
		return axios.get(`/api/duties`);
	},

	loadDutyActivities(dutyId) {
		return axios.get(`/api/duties/${dutyId}/dutyactivities`);
	},
};
